import Vue from "vue"
import index from "./index.vue"

let Loading = Vue.extend(index)
let instance

export default {
    open(options) {
        if (!instance) {
            instance = new Loading({
                el: document.createElement("div")
            })
            document.body.appendChild(instance.$el)
        }
        if (typeof options != "object") {
            instance.text = options
        } else {
            Object.assign(instance, options)
        }

        Vue.nextTick(() => {
            instance.show = true
        })
    },
    close() {
        instance.show = false
    }
}


// WEBPACK FOOTER //
// ./src/components/loading/index.js